import { getElementsInProposal } from '@shared/helpers/proposal.helpers';
import { Baseline } from '@shared/models/project.model';
import { isElementOfCategory } from '@shared/helpers/element-category.helpers';
import { ElementCategoryID } from '@shared/models/element-categories.model';
import { CoolingPropertyName } from './cooling.model';
import { getElementPropertyResolvedCountByNameOrId } from '@shared/helpers/element-property.helpers';
import { sum } from '@shared/helpers/math.helpers';

/**
 * Get all active cooling elements in the version
 * @param version
 * @returns
 */
const getActiveCoolingElements = (version: Baseline) =>
  getElementsInProposal(version).filter((element) =>
    isElementOfCategory(element, ElementCategoryID.Cooling),
  );

/**
 * Get the total max cooling capacity in the version in kW
 * @param version
 * @returns The max cooling capacity in the version in kW
 */
export const getCoolingMaxCapacityInVersion = (version: Baseline): number => {
  return sum(
    getActiveCoolingElements(version).map((e) =>
      getElementPropertyResolvedCountByNameOrId(
        e,
        CoolingPropertyName.MaxCapacity,
        0,
      ),
    ),
  );
};
